import React, { useState } from 'react';
import { formInputTextErrorStyle, routes } from 'Utility/constants';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as actions from '../../../redux/actions/index';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'react-loader-spinner';
import { validateSignupForm } from '../../../Utility/validator/formValidation';

const Regitser = (props) => {
   let dispatch = useDispatch();
   const [visible, setVisible] = useState({password: false, confirmPassword: false})

   let isLoading = useSelector((state) => state.authReducer.isLoading);

   const initialFormValues = {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      confirmpass: '',
   };

   const handleVisible = (type) => {
      if(type === 'password') {
         setVisible({...visible, password: !visible.password})
      } else {
         setVisible({...visible, confirmPassword: !visible.confirmPassword})
      }
   }

   return (
      <div id="wrap">
         <div className="wrap-login100">
            <Formik
               initialValues={initialFormValues}
               onSubmit={(request) => {
                  let values = { ...request };
                  delete values.confirmpass;
                  let email = values.email.trim();
                  values.email = email.toLowerCase();
                  values.first_name = values.first_name.trim();
                  values.last_name = values.last_name.trim();
                  dispatch(actions.signup({ user: { ...values } }));
               }}
               validate={(values) => validateSignupForm(values)}
            >
               {(formik_props) => {
                  return (
                     <Form className="login100-form validate-form">
                        <span className="login100-form-title">Sign Up</span>
                        <fieldset className="form_fields">
                           <div className="form-group">
                              <Field
                                 className="input_modify"
                                 type="text"
                                 name="first_name"
                                 placeholder="First Name"
                              />
                              <ErrorMessage
                                 name="first_name"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                           <div className="form-group">
                              <Field
                                 className="input_modify"
                                 type="text"
                                 name="last_name"
                                 placeholder="Last Name"
                              />
                              <ErrorMessage
                                 name="last_name"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                           <div className="form-group">
                              <Field
                                 className="input_modify text-lowercase"
                                 type="email"
                                 name="email"
                                 placeholder="Email"
                              />
                              <ErrorMessage
                                 name="email"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                           <div className="form-group" style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                 <Field
                                    className="input_modify"
                                    type={visible.password ? 'text' : 'password'}
                                    name="password"
                                    placeholder="Password"
                                    style={{ width: "100%" }}
                                 />
                                 <span
                                    onClick={() => handleVisible('password')}
                                    style={{
                                       position: 'absolute',
                                       top: '50%',
                                       right: '10px',
                                       transform: 'translateY(-50%)',
                                       cursor: 'pointer',
                                       zIndex: 2,
                                       display: 'flex',
                                       alignItems: 'center',
                                       height: '100%',
                                    }}
                                    title={visible.password ? "Hide Password" : "Show Password"}
                                 >
                                    {!visible.password ? (
                                       <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                    ) : (
                                       <i className="fa fa-eye" aria-hidden="true"></i>
                                    )}
                                 </span>
                              </div>
                              <ErrorMessage
                                 name="password"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                           <div className="form-group" style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                 <Field
                                    className="input_modify"
                                    type={visible.confirmPassword ? 'text' : 'password'}
                                    name="confirmpass"
                                    placeholder="Confirm Password"
                                    style={{ width: "100%" }}
                                 />
                                 <span
                                    onClick={() => handleVisible('confirmPassword')}
                                    style={{
                                       position: 'absolute',
                                       top: '50%',
                                       right: '10px',
                                       transform: 'translateY(-50%)',
                                       cursor: 'pointer',
                                       zIndex: 2,
                                       display: 'flex',
                                       alignItems: 'center',
                                       height: '100%',
                                    }}
                                    title={visible.confirmPassword ? "Hide Password" : "Show Password"}
                                 >
                                    {!visible.confirmPassword ? (
                                       <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                    ) : (
                                       <i className="fa fa-eye" aria-hidden="true"></i>
                                    )}
                                 </span>
                              </div>
                              <ErrorMessage
                                 name="confirmpass"
                                 render={(msg) => (
                                    <span style={formInputTextErrorStyle}>
                                       {msg}
                                    </span>
                                 )}
                              />
                           </div>
                        </fieldset>

                        <div className="form-group text-center">
                           <button
                              disabled={isLoading ? true : false}
                              type="submit"
                              className="theme_btn theme_primary btn-block"
                           >
                              {isLoading ? (
                                 <Loader
                                    type="Circles"
                                    color="#FFF"
                                    height={25}
                                    width={80}
                                 />
                              ) : (
                                 'Sign Up'
                              )}
                           </button>
                        </div>

                        <a
                           href="javascript:void(0)"
                           onClick={() => props.history.push(routes.LOGIN)}
                           className="form_link"
                        >
                           Sign In
                        </a>
                     </Form>
                  );
               }}
            </Formik>
         </div>
      </div>
   );
};

export default withRouter(Regitser);
